import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

const ActionWrapper = ({ direction, title, loading, ...props }) => (
  <Container>
    <Title loading={loading}>{title}</Title>
    <Children direction={direction}>{props.children}</Children>
  </Container>
)

export default ActionWrapper

const Container = glamorous.div(
  {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "3rem",
    [style.size.desktop]: {
      padding: "1rem",
    },
  },
  ({ direction }) => ({
    flexDirection: direction,
  })
)

const Children = glamorous.div(
  {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop: "2rem",
  },
  ({ direction }) => ({
    flexDirection: direction,
    [style.size.desktop]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  })
)

const Title = glamorous.h1(
  {
    color: style.colors.green,
    fontSize: "2rem",
  },
  props => ({
    filter: props.loading ? "blur(5px)" : "none",
  })
)



// WEBPACK FOOTER //
// ./src/containers/ActionWrapper/index.js